import { INTRANET_PATHS } from '../components/AppNavbar.js'

// Governance registers `isActiveMember` as a method on the project. Apps
// that don't (canvas editor) default to active so the AppHeader stays
// usable. Reads directly from `ctx.methods` — never exported under the
// same name into `ctx.functions` to avoid self-recursion via `el.call`.
export const checkActiveMember = (el) => {
  const fn = el?.context?.methods?.isActiveMember
  if (typeof fn !== 'function') return true
  return !!fn.call(el, el?.state)
}

export const isIntranetRoute = (s) => {
  const path = s?.root?.currentPath || s?.root?.route || '/'
  return INTRANET_PATHS.includes(path)
}
